import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Overview from './pages/Overview';
import Agreement from './pages/Agreement';
import Documents from './pages/Documents';
import ReadinessForm from './pages/ReadinessForm';
import Payments from './pages/Payments';
import './index.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Overview />} />
          <Route path="agreement" element={<Agreement />} />
          <Route path="documents" element={<Documents />} />
          <Route path="readiness" element={<ReadinessForm />} />
          <Route path="payments" element={<Payments />} />
        </Route>
      </Routes>
    </Router>
  </React.StrictMode>
);

reportWebVitals();
